import { DITypes } from "@/core/@types/types";
import type { HttpClient } from "@/core/services/protocols/types";
import { inject, injectable } from "inversify";
import Interesse from "./Interesse";
import {
  IInteresseParams,
  IInteressesGateway,
  IInteressesResponse
} from "./InteressesGateway";

const baseUrl = "/financas/preferenciascliente/v1";

@injectable()
export default class InteressesHttpGateway implements IInteressesGateway {
  @inject(DITypes.INDICADORES_HTTP_CLIENT)
  private httpClient!: HttpClient;

  async getInteresses(): Promise<Interesse> {
    const { body } = await this.httpClient.get<IInteressesResponse>({
      url: `${baseUrl}/obter-preferencias`
    });

    return new Interesse(body);
  }

  async postInteresses(params: IInteresseParams): Promise<IInteressesResponse> {
    const { body } = await this.httpClient.post<
      IInteressesResponse | undefined
    >({
      url: `${baseUrl}/salvar-preferencias`,
      body: { ...params }
    });

    return body || [];
  }
}
